import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";

const initialState = {
  loading: false,
  createqr: [],
  totalCount: 0,
};

const slice = createSlice({
  name: "createqr",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    
    // view user relative
    builder.addCase(Act.CreateQR.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.CreateQR.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      createqr: payload,
    }));
    builder.addCase(Act.CreateQR.rejected, (state, action) => ({
      ...state,
      loading: false,
      createqr: null,
    }));
    // user relative profile
    builder.addCase(Act.QRDETAILS.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.QRDETAILS.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      createqr: payload,
    }));
    builder.addCase(Act.QRDETAILS.rejected, (state, action) => ({
      ...state,
      loading: false,
      createqr: null,
    }));
//     // delete photo
//    builder.addCase(Act.deletePhoto.pending, (state) => {
//       state.loading = true;
//       state.error = null;
//     })
//     builder .addCase(Act.deletePhoto.fulfilled, (state, action) => {
//       state.loading = false;
//       state.error = null;

//     })
//     builder.addCase(Act.deletePhoto.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.error.message || action.error;
//     });

//     // delete video
//     builder.addCase(Act.deleteVideo.pending, (state) => {
//       state.loading = true;
//       state.error = null;
//     })
//     builder .addCase(Act.deleteVideo.fulfilled, (state, action) => {
//       state.loading = false;
//       state.error = null;

//     })
//     builder.addCase(Act.deleteVideo.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.error.message || action.error;
//     });
//     // arcieve users relatives
//     builder.addCase(Act.ARCHIEV_RELATIVE.pending, (state) => {
//       state.loading = true;
//       state.error = null;
//     })
//     builder .addCase(Act.ARCHIEV_RELATIVE.fulfilled, (state, action) => {
//       state.loading = false;
//       state.error = null;

//     })
//     builder.addCase(Act.ARCHIEV_RELATIVE.rejected, (state, action) => {
//       state.loading = false;
//       state.error = action.error.message || action.error;
//     });
     },
});

export default slice;
